import React from 'react';
import '../ChoosePersonStep.scss';
import DynaInput from "../../../../DynaView/DynaInput";
import DynaTextarea from "../../../../DynaView/DynaTextarea";

const AddLegalPerson = ({sendData, setSendData}) => {

  return (
    <div className={"add-person-form"}>
      <DynaInput label={"شناسه ملی"}
                 name={"nationalId"}
                 className={"solid-dyna-input"}
                 placeholder={"شناسه ملی را وارد کنید"}
                 value={sendData?.nationalId}
                 type={"text"}
                 setDataFromComponent={(data) => {
                   setSendData({...sendData, ...data})
                 }}
      />
      <DynaInput label={"عنوان سازمان"}
                 name={"organizationName"}
                 className={"solid-dyna-input"}
                 placeholder={"عنوان سازمان را وارد کنید"}
                 value={sendData?.organizationName}
                 type={"text"}
                 setDataFromComponent={(data) => {
                   setSendData({...sendData, ...data})
                 }}
      />
      <DynaInput label={"شماره موبایل"}
                 name={"mobileNumber"}
                 className={"solid-dyna-input"}
                 placeholder={"شماره موبایل را وارد کنید"}
                 value={sendData?.mobileNumber}
                 type={"text"}
                 setDataFromComponent={(data) => {
                   setSendData({...sendData, ...data})
                 }}
      />
      <DynaInput label={"شماره تلفن"}
                 name={"telephone"}
                 className={"solid-dyna-input"}
                 placeholder={"شماره تلفن را وارد کنید"}
                 value={sendData?.telephone}
                 type={"text"}
                 setDataFromComponent={(data) => {
                   setSendData({...sendData, ...data})
                 }}
      />
      <DynaInput label={"کد اقتصادی"}
                 name={"economicCode"}
                 className={"solid-dyna-input"}
                 placeholder={"کد اقتصادی را وارد کنید"}
                 value={sendData?.economicCode}
                 type={"text"}
                 setDataFromComponent={(data) => {
                   setSendData({...sendData, ...data})
                 }}
      />
      <DynaInput label={"نام مسئول"}
                 name={"personName"}
                 className={"solid-dyna-input"}
                 placeholder={"نام مسئول را وارد کنید"}
                 value={sendData?.personName}
                 type={"text"}
                 setDataFromComponent={(data) => {
                   setSendData({...sendData, ...data})
                 }}
      />
      <div style={{gridColumn: "1 / -1"}}>
        <DynaTextarea label={"آدرس"}
                      name={"address"}
                      style={{height: '80px'}}
                      className={"solid-dyna-input"}
                      placeholder={"آدرس را وارد کنید"}
                      value={sendData?.address}
                      type={"text"}
                      setDataFromComponent={(data) => {
                        setSendData({...sendData, ...data})
                      }}
        />
      </div>
      <DynaInput label={"کد پستی"}
                 name={"postalCode"}
                 className={"solid-dyna-input"}
                 placeholder={"کد پستی را وارد کنید"}
                 value={sendData?.postalCode}
                 type={"text"}
                 setDataFromComponent={(data) => {
                   setSendData({...sendData, ...data})
                 }}
      />

    </div>
  );
};

export default AddLegalPerson;